import { Link } from 'react-router-dom';
import type { ContentItem } from '@/types';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
}

export function SectionHeader({ title, subtitle, moreLink, moreText = '查看更多' }: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between mb-5 md:mb-6">
      <div>
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-100">{title}</h2>
        {subtitle && <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>}
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap"
        >
          {moreText}
          <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      )}
    </div>
  );
}